import { defineComponent as _defineComponent } from 'vue'
import { useContext, useStore, useRoute } from '@nuxtjs/composition-api';
import { State } from '~/store';

interface Props {
  isFree?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PlanCtaPill',
  props: {
    isFree: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isFree?: boolean;
};

const { $config, i18n } = useContext();
const store = useStore<State>();
const route = useRoute();



return { __sfc: true,$config, i18n, store, route, props }
}

})